/* eslint-disable */
import { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { notification } from "antd";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import { usePostEmulatorCommandMutation } from "../../redux/monitoring/monitoringAPI";
import { updateSendCommand } from "../../redux/monitoring/monitoringSlice";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { RootState } from "../../app/store";

export default function usePostCommand() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { socketConnection, liftSelected, bankSelected, serverId } = useSelector(
    (state: RootState) => state.monitoring,
  );
  const { theme, userLogged } = useSelector((state: RootState) => state.home);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [
    triggerCommandEmulator,
    {
      isLoading: isLoadingPostCommandEmulator,
      isSuccess: isSuccessPostCommandEmulator,
      isError: isErrorPostCommandEmulator,
      reset: resetPostEmulatorCommand,
    },
  ] = usePostEmulatorCommandMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const getLiftId = () => {
    if (liftSelected && liftSelected.id && liftSelected.id !== "") {
      return liftSelected.id;
    }
    const liftId = bankSelected?.lifts?.[0]?.id;
    if (liftId && liftId !== "") {
      return liftId;
    }
    return "";
  };

  const postCommandEmulator = async (floor: number) => {
    const token = await GETJwtToken();
    const BODY = {
      token,
      body: {
        // eslint-disable-next-line no-constant-condition
        type: false ? "SECURE_CARCALL" : "CARCALL",
        lift_id: getLiftId(),
        floor,
        bank_id: bankSelected.id,
        front_rear: "front",
      },
      serverId,
    };
    triggerCommandEmulator(BODY);
  };

  const postCommandElevator = async (floor: number, command: number, active: boolean) => {
    if (bankSelected && bankSelected.id) {
      const BODY = {
        command,
        position: floor,
        active,
        bankId: bankSelected.id,
        liftId: getLiftId(),
      };
      console.log("POST COMMAND ELEVATOR");
      console.log(JSON.stringify(BODY, null, 4));
      dispatch(
        updateSendCommand({
          sendCommand: true,
          serverId: "",
          body: BODY,
        }),
      );
    }
  };

  const triggerPostCommand = async ({
    floor,
    command,
    liftType,
    active,
  }: {
    floor: number;
    command: number;
    liftType: "ELEVATOR" | "ESCALATOR";
    active: boolean;
  }) => {
    if (socketConnection === "EDGE" || socketConnection === "OFFLINE") {
      if (liftType === "ELEVATOR") {
        postCommandElevator(floor, command, active);
      }
    } else if (socketConnection === "EMULATOR") {
      postCommandEmulator(floor);
    }
  };

  const launchSuccessNotification = () => {
    if (userLogged.command_notifications) {
      notification.success({
        message: "Command sent successfully",
        description: `${socketConnection} Command`,
        placement: "top",
        className: `monitoring__notification__${theme}`,
      });
    }
  };

  const launchErrorNotification = () => {
    if (userLogged.command_notifications) {
      notification.error({
        message: "Error",
        description: `${socketConnection} Command`,
        placement: "top",
        className: `monitoring__notification__${theme}`,
      });
    }
  };

  // ************************************************ */
  // USE EFFECT ************************************* */
  useEffect(() => {
    if (isSuccessPostCommandEmulator) {
      launchSuccessNotification();
      resetPostEmulatorCommand();
    }
  }, [isSuccessPostCommandEmulator]);

  useEffect(() => {
    if (isErrorPostCommandEmulator) {
      launchErrorNotification();
      resetPostEmulatorCommand();
    }
  }, [isErrorPostCommandEmulator]);

  // ************************************************ */
  // COMPONENT ************************************** */

  return {
    triggerPostCommand,
    isLoadingPostCommand: isLoadingPostCommandEmulator,
    isErrorPostCommand: isErrorPostCommandEmulator,
    isSuccessPostCommand: isSuccessPostCommandEmulator,
  };
}
